(function () {
    'use strict';

    function workflowRouteConfig($stateProvider) {

        $stateProvider
            .state('admincontractorprojectupdate', {
                url: '/admin/contractorprojects/update/:contractorProjectId',
                template: '<contractor-project></contractor-project>',
                controller: 'contractorProjectController',
                controllerAs: 'editor',
                resolve: {
                    adminMode: function () {
                        return true;
                    }
                }
            })
            .state('admincontractorprojectphaseupdate', {
                url: '/admin/contractorprojects/update/:contractorProjectId/:phaseIndex',
                template: '<contractor-project></contractor-project>',
                controller: 'contractorProjectController',
                controllerAs: 'editor',
                resolve: {
                    adminMode: function () {
                        return true;
                    }
                }
            })
            .state('entitycontractorprojectreview', {
                url: '/entities/projects/review/:contractorProjectId',
                template: '<contractor-project></contractor-project>',
                controller: 'contractorProjectController',
                controllerAs: 'editor',
                resolve: {
                    adminMode: function () {
                        return false;
                    }
                }
            })
            .state('entitycontractorprojectreviewstate', {
                url: '/entities/projects/review/:contractorProjectId/:phaseIndex',
                template: '<contractor-project></contractor-project>',
                controller: 'contractorProjectController',
                controllerAs: 'editor',
                resolve: {
                    adminMode: function () {
                        return false;
                    }
                }
            })
            .state('createWorkflow', {
                url: '/workflows/create?t',
                templateUrl: 'workflow/templates/createWorkflow.html',
                controller: 'createWorkflowController as createWorkflowCtrl',
                resolve: {
                    workflowConfigurationData: [
                        "workflowConfigurationDataService", "$stateParams", function (workflowConfigurationDataService, $stateParams) {
                            return workflowConfigurationDataService.getWorkflowConfiguration($stateParams.t);
                        }
                    ],
                    entity: function () { return null; },
                    sessionData: function () { return null; }
                }
            })
            .state('createWorkflowForEntity', {
                url: '/workflows/:entityType/:entityId/create?t',
                templateUrl: 'workflow/templates/createWorkflow.html',
                controller: 'createWorkflowController as createWorkflowCtrl',
                resolve: {
                    sessionData: [
                        "sessionDataService", "$state", "notifyService", function (sessionDataService, $state, notifyService) {
                            return sessionDataService.loadSession().then(function (data) {
                                if (!data.IsAdminEntity) {
                                    $state.go('dashboard').then(function () {
                                        notifyService.notify('You do not have permission to create projects for users', true);
                                      });
                                }
                                return data;
                            });
                        }
                    ],
                    workflowConfigurationData: [
                        "workflowConfigurationDataService", "$stateParams", function (workflowConfigurationDataService, $stateParams) {
                            return workflowConfigurationDataService.getWorkflowConfiguration($stateParams.t, $stateParams.entityType, $stateParams.entityId);
                        }
                    ],
                    entity: [
                        "platformEntitiesDataService", "$stateParams", function (platformEntitiesDataService, $stateParams) {
                            if ($stateParams.entityId) {
                                return platformEntitiesDataService.loadPlatformEntity($stateParams.entityType + '/' + $stateParams.entityId);
                            }
                        }
                    ]
                }
            })
            .state('workflow', {
                url: '/workflows/review/:workflowId',
                templateUrl: 'workflow/templates/workflow.html',
                controller: 'workflowController as workflowContainerCtrl',
                resolve: {
                    functionsConfigurationData: [
                        "functionsConfigurationDataService", function (functionsConfigurationDataService) {
                            return functionsConfigurationDataService.loadConfiguration().then(function (data) {
                                return data;
                            });
                        }
                    ],
                    sessionData: [
                        "sessionDataService", function (sessionDataService) {
                            return sessionDataService.loadSession().then(function (data) {
                                return data;
                            });
                        }
                    ],
                    workflowData: [
                        "$stateParams", "workflowDataService", "workflowStateService",
                        function ($stateParams, workflowDataService, workflowStateService) {
                            return workflowDataService.loadWorkflow('workflows/' + $stateParams.workflowId).then(function (data) {
                                return workflowStateService.update(data, true);
                            });
                        }
                    ],
                    thumbnailsData: [
                        "$stateParams", "thumbnailsDataService", "workflowStateService",
                        function ($stateParams, thumbnailsDataService, workflowStateService) {
                            return thumbnailsDataService.loadThumbnails('workflows/' + $stateParams.workflowId).then(function (data) {
                                workflowStateService.setThumbnails(data);
                                return data;
                            });
                        }
                    ]
                },
                redirectTo: 'workflow.roadmap'
            })
            .state('workflow.path', {
                url: '/path?path',
                templateUrl: 'workflow/templates/path.html',
                controller: 'workflowPathController as workflowPathCtrl'
            })
            .state('workflow.roadmap', {
                url: '/roadmap?path',
                templateUrl: 'workflow/templates/roadmap.html',
                controller: 'workflowRoadmapController as workflowRoadmapCtrl',
                resolve: {
                    milestones: function () {
                        return ['Workflow', 'WorkflowRoadmapTab'];
                    },
                    roadmapThumbnails: [
                        "$stateParams", "thumbnailsDataService", "workflowData",
                        function ($stateParams, thumbnailsDataService, workflowData) {
                            var phasePaths = workflowData.Phases.filter(function (phase) {
                                return phase.Access.View && !phase.IsRemoved;
                            }).map(function (filteredPhase) {
                                return filteredPhase.Path;
                            });
                            return thumbnailsDataService.loadThumbnailsForObjectPaths('workflows/' + $stateParams.workflowId,
                                phasePaths
                            ).then(function (data) {
                                Object.keys(data).forEach(function (key) {
                                    var matchingThumbnailObj = data[key];
                                    var prefix = matchingThumbnailObj.IsTemplate ? 'gettemplate' : 'getupload';
                                    if (matchingThumbnailObj.Thumbnails && matchingThumbnailObj.Thumbnails.length > 0) {
                                        matchingThumbnailObj.ThumbnailUrl = '/files/' + prefix + '?blobreference=' + matchingThumbnailObj.Thumbnails[0] + '&fileName='+ matchingThumbnailObj.Thumbnails[0];
                                    }
                                })
                                return data;
                            });
                        }
                    ]
                }
            })
            .state('workflow.navigator', {
                url: '/navigator',
                templateUrl: 'workflow/templates/workflowNavigator.html',
                controller: 'workflowNavigatorController as workflowCtrl',
                resolve: {
                    entitySearches: [
                        '$stateParams', 'sessionData', 'workflowDataService',
                        function ($stateParams, sessionData, workflowDataService) {
                            if (sessionData.EntityType === 'Portal Administrator') {
                                return workflowDataService.getEntitySearches('workflows/' +
                                    $stateParams.workflowId).then(function (data) {
                                        return data;
                                    });
                            } else {
                                return [];
                            }
                        }
                    ],
                    milestones: function () {
                        return ['Workflow', 'WorkflowNavigatorTab'];
                    },
                    phaseThumbnails: [
                        "$stateParams", "workflowThumbnailsService", "workflowData",
                        function ($stateParams, workflowThumbnailsService, workflowData) {
                            return workflowThumbnailsService.getThumbnails($stateParams.workflowId, workflowData).then(function (data) {
                                return data;
                            });
                        }
                    ]
                }
            })
            .state('workflow.navigator.phase', {
                url: '/phase/:phaseIndex?path'
            })
            .state('workflow.summary', {
                url: '/summary',
                templateUrl: 'workflow/templates/workflowSummary.html',
                controller: 'workflowSummaryController as workflowSummaryCtrl',
                resolve: {
                    milestones: function () {
                        return ['Workflow', 'WorkflowSummaryTab'];
                    }
                }
            })
            .state('workflow.internalfiles', {
                url: '/internalfiles?path',
                templateUrl: 'workflow/templates/internalFiles.html',
                controller: 'workflowInternalFilesController as workflowInternalFilesCtrl',
                resolve: {
                    milestones: function () {
                        return ['Workflow', 'WorkflowInternalFilesTab'];
                    },
                    thumbnails: [
                        "$stateParams", "workflowThumbnailsService", "workflowData",
                        function ($stateParams, workflowThumbnailsService, workflowData) {
                            return workflowThumbnailsService.getThumbnails($stateParams.workflowId, workflowData).then(function (data) {
                                return data;
                            });
                        }
                    ]
                }
            })
            .state('workflow.sharing',
            {
                url: '/share',
                templateUrl: 'workflow/templates/sharing.html',
                controller: 'workflowSharingController as workflowSharingCtrl',
                resolve: {
                    milestones: function () {
                        return ['Workflow', 'WorkflowSharingTab'];
                    }
                }
            })
            .state('workflow.sharingsearch', {
                url: '/sharingsearch/:entitySearchIndex/path/:path',
                templateUrl: 'workflow/templates/sharingsearch.html',
                controller: 'workflowSharingSearchController as workflowSharingSearchCtrl',
                resolve: {
                    entitySearchConfiguration: [
                        '$stateParams', 'searchConfigurationDataService', function ($stateParams, searchConfigurationDataService) {
                            return searchConfigurationDataService.loadEntitiesSearch($stateParams.entitySearchIndex, $stateParams.workflowId)
                                .then(function (data) {
                                    return data;
                                });
                        }
                    ],
                    milestones: function () {
                        return ['Workflow', 'WorkflowSharingSearch', 'PartnerSearchWizard'];
                    }
                }
            })
            .state('workflow.sharingsearchWithAdminSearch', {
                url: '/search/:entitySearchIndex/:adminEntitySearchIndex/path/:path',
                templateUrl: 'workflow/templates/sharingsearch.html',
                controller: 'workflowSharingSearchController as workflowSharingSearchCtrl',
                resolve: {
                    entitySearchConfiguration: [
                        '$stateParams', 'searchConfigurationDataService', function ($stateParams, searchConfigurationDataService) {
                            return searchConfigurationDataService.loadEntitiesSearch($stateParams.entitySearchIndex, $stateParams.workflowId)
                                .then(function (data) {
                                    return data;
                                });
                        }
                    ],
                    milestones: function () {
                        return ['Workflow', 'WorkflowSharingSearch', 'PartnerSearchWizard'];
                    }
                }
            })
            .state('workflow.sharingsearch.internalfiles', {
                url: '/internalfiles',
                resolve: {
                    milestones: function () {
                        return ['Workflow', 'WorkflowSharingSearch', 'PartnerSearchWizard'];
                    }
                }
            })
            .state('workflow.sharingsearch.phase', {
                url: '/phase/:phaseIndex',
                resolve: {
                    milestones: function () {
                        return ['Workflow', 'WorkflowSharingSearch', 'PartnerSearchWizard'];
                    }
                }
            })
            .state('workflow.sharingsearchWithAdminSearch.internalfiles', {
                url: '/internalfiles',
                resolve: {
                    milestones: function () {
                        return ['Workflow', 'WorkflowSharingSearch', 'PartnerSearchWizard'];
                    }
                }
            })
            .state('workflow.sharingsearchWithAdminSearch.phase', {
                url: '/phase/:phaseIndex',
                resolve: {
                    milestones: function () {
                        return ['Workflow', 'WorkflowSharingSearch', 'PartnerSearchWizard'];
                    }
                }
            })
            .state('workflow.documents',
            {
                url: '/documents',
                templateUrl: 'workflow/templates/documents.html',
                controller: 'workflowDocumentsController as workflowDocumentsCtrl',
                resolve: {
                    milestones: function () {
                        return ['Workflow', 'WorkflowDocumentsTab'];
                    }
                }
            })
            .state('workflow.notes',
            {
                url: '/notes',
                templateUrl: 'workflow/templates/notes.html',
                controller: 'workflowNotesController as workflowNotesCtrl',
                resolve: {
                    milestones: function () {
                        return ['Workflow', 'WorkflowNotesTab'];
                    }
                }
            });
    }

    workflowRouteConfig.$inject = ['$stateProvider'];

    angular.module('ecap.workflow').config(workflowRouteConfig);
})();